import { defineComponent as _defineComponent } from 'vue'
import { Icon } from '@iconify/vue2'
import { onMounted, ref } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'Accordion',
  props: {
	label: String,
	startOpened: {
		type: Boolean,
		default: false,
	},
},
  setup(__props) {

const props = __props;



const opened = ref(false)

onMounted(() => {
	opened.value = props.startOpened
})

return { __sfc: true,props, opened, Icon }
}

})